import React from "react";
// Components
import {
  GroupContainer,
  ColumnLabels,
  ColumnLabel,
  GroupHeader,
  GroupTitle,
  HeaderValue,
  RowContainer,
  RowInfo,
  RowName,
  Feature,
  RowValue,
} from "./styles";
import Stepper from "../stepper";

const LicenseGroup = ({ title, columnLabels, name, features, therapists, years, total }) => (
  <GroupContainer>
    <ColumnLabels>
      <span />
      <ColumnLabel>{columnLabels.therapists}</ColumnLabel>
      <ColumnLabel>{columnLabels.years}</ColumnLabel>
      <ColumnLabel>{columnLabels.total}</ColumnLabel>
    </ColumnLabels>

    <GroupHeader>
      <GroupTitle>{title}</GroupTitle>
      <span />
      <span />
      <HeaderValue>{total}</HeaderValue>
    </GroupHeader>

    <RowContainer>
      <RowInfo>
        <RowName>{name}</RowName>
        {features.map((feature, i) => (
          <Feature key={i}>{feature}</Feature>
        ))}
      </RowInfo>
      <Stepper value={therapists.value} onChange={therapists.onChange} max={therapists.max} />
      <Stepper value={years.value} onChange={years.onChange} max={years.max} />
      <RowValue>{total}</RowValue>
    </RowContainer>
  </GroupContainer>
);

export default LicenseGroup;
